export const REACH_METHODS = [
  {
    value: 'email',
    label: 'Email',
  },
  {
    value: 'phone',
    label: 'Phone',
  },
  {
    value: 'twitter',
    label: 'Twitter',
  },
  {
    value: 'telegram',
    label: 'Telegram',
  },
  {
    value: 'discord',
    label: 'Discord',
  },
];

export const SOURCES = [
  {
    value: 'contact',
    label: 'Contact',
  },
  {
    value: 'flow',
    label: 'Flow',
  },
  {
    value: 'import',
    label: 'Import',
  },
  {
    value: 'list',
    label: 'List',
  },
  {
    value: 'profile',
    label: 'Profile',
  },
];
